/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum Lang {
	Ro = "RO",
	En = "EN",
	Fr = "FR",
	De = "DE",
}

export function LangFromJSON(json: any): Lang {
	return LangFromJSONTyped(json, false);
}

export function LangFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): Lang {
	return json as Lang;
}

export function LangToJSON(value?: Lang | null): any {
	return value as any;
}
